<template>
  <b-modal :active="true" @close="onClose" custom-class="modal-wrapper">
    <div class="content">
      <h2>Instruments Out of Calibration</h2>
      <b-notification type="is-warning" :closable="false">
        One or more tools selected is out of calibration. Please see supervisor
        or quality team.
      </b-notification>

      <b-field label="Please enter your comments here... ">
        <b-input
          v-model="inspectorComments"
          maxlength="200"
          type="textarea"
        ></b-input>
      </b-field>
      <h4>Do you want to proceed?</h4>
      <footer class="footer-buttons">
        <b-button label="Close" @click="onClose" />
        <b-button label="OK" type="is-primary" @click="onSubmit" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'OutOfCalibrationDateModal',
  props: {},
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    async onSubmit() {
      this.$emit('onSave');
    },
  },
  data() {
    return {
      inspectorComments: '',
    };
  },
  computed: {},
};
</script>

<style scoped>
.footer-buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
}

.footer-buttons button {
  flex-grow: 1; /* Causes the buttons to grow and fill the container */
}

.modal-content {
  width: 100%;
  display: flex;
  justify-content: center;
}

.content {
  background: white;
  border-radius: 10px;
  padding: 38px;
  margin: 0 25%;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
</style>
